
import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-20 bg-gradient-to-br from-[#1B365D] to-[#2BB6A3]">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-4xl font-bold mb-6">
            Ready to Build Predictable Revenue?
          </h2>
          <p className="text-xl mb-8 opacity-90">
            Join 75+ companies that have transformed their revenue with our AI-powered systems. 
            Get your free assessment and discover your growth opportunities.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/free-assessment"
              className="bg-white text-[#1B365D] px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap"
            >
              Get Free Assessment
            </Link>
            <Link
              to="/case-studies"
              className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-[#1B365D] transition-colors whitespace-nowrap"
            >
              View Success Stories
            </Link>
          </div>
          <div className="mt-8 text-sm opacity-80">
            ✓ 30-minute consultation ✓ Custom growth roadmap ✓ No obligation
          </div>
        </div>
      </div>
    </section>
  );
}
